export const gridConf: any = {
    guidelinesStyle: {
        strokeStyle: "#4fe7ff",
        lineDash: [5, 5],
        horizontalDistColor: "#4fe7ff",
        horizontalDistLine: [5, 5],
        verticalDistColor: "#4fe7ff",
        verticalDistLine: [5, 5],
        initPosAlignmentColor: "#4fe7ff",
        range: 500,
        geometricGuidelineRange: 600
    },
    gridColor: "#f2f1f1",
    snapToAlignmentLocationOnRelease: true,
    snapToAlignmentLocationDuringDrag: false,
    distributionGuidelines: true,
    geometricGuideline: true
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/MessageFlow/grid-conf.ts